export class UserSelectionInformation {
  fixedPhraseDragAndDropMode: string;

  public toStoreObject(): any {
    return {
      fixedPhraseDragAndDropMode: this.fixedPhraseDragAndDropMode,
    };
  }

  public static fromStoreObject(storeObject: any): UserSelectionInformation {
    if (!storeObject) { return null; }
    const info = new UserSelectionInformation();
    info.fixedPhraseDragAndDropMode = storeObject.fixedPhraseDragAndDropMode;
    return info;
  }

  public clone(): UserSelectionInformation {
    const cloned = new UserSelectionInformation();
    cloned.fixedPhraseDragAndDropMode = this.fixedPhraseDragAndDropMode;
    return cloned;
  }
}
